export default __webpack_public_path__ + "static/media/mesh-background.a2b0b7d6.svg";